import { useTranslation } from "react-i18next";
import { Globe2, Sparkles, Users2 } from "lucide-react";
import Footer from "src/Components/Footer/Footer";
import { Mission } from "../Components/Company/Mission";
import Navbar from "../Components/Header/Navbar";

export const Company = () => {
  const { t } = useTranslation();

  const stats = [
    {
      label: t("company.stats.mission.label"),
      value: t("company.stats.mission.value"),
      icon: Sparkles,
    },
    {
      label: t("company.stats.team.label"),
      value: t("company.stats.team.value"),
      icon: Users2,
    },
    {
      label: t("company.stats.impact.label"),
      value: t("company.stats.impact.value"),
      icon: Globe2,
    },
  ];

  return (
    <div className="relative min-h-[100dvh] w-full overflow-clip bg-gradient-to-br from-slate-900 via-gray-900 to-slate-800 flex flex-col">
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-gradient-to-br from-purple-500/20 to-blue-500/20 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-gradient-to-tr from-indigo-500/20 to-cyan-500/20 blur-3xl" />
        <div className="absolute left-1/2 top-1/3 h-[420px] w-[780px] -translate-x-1/2 rounded-full bg-gradient-to-r from-blue-100/10 to-purple-100/10 blur-3xl" />
      </div>

      <div className="relative z-10 flex flex-1 flex-col">
        <Navbar />

        <main className="flex-1 px-4 pb-20 pt-[150px] md:px-6 lg:px-10">
          <div className="mx-auto max-w-7xl">
            <div className="mb-10 text-center lg:mb-12 lg:text-left">
              <p className="text-sm font-semibold uppercase tracking-[0.35em] text-blue-200/80">
                {t("company.pageTag")}
              </p>
              <h1 className="mt-4 text-3xl font-bold tracking-tight text-white md:text-5xl lg:text-6xl">
                {t("company.pageTitle")}
              </h1>
              <p className="mx-auto mt-3 max-w-3xl text-base leading-7 text-slate-300 md:mt-4 md:text-lg lg:mx-0">
                {t("company.pageSubtitle")}
              </p>
            </div>

            <div className="grid gap-4 md:grid-cols-3 mb-10">
              {stats.map((stat) => {
                const Icon = stat.icon;

                return (
                  <div
                    key={stat.label}
                    className="rounded-2xl border border-white/10 bg-white/5 p-5 shadow-2xl shadow-black/20 backdrop-blur-xl"
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500/20 to-purple-500/20 border border-white/10">
                        <Icon className="h-5 w-5 text-blue-100" />
                      </div>
                      <div>
                        <p className="text-sm uppercase tracking-[0.25em] text-slate-400">
                          {stat.label}
                        </p>
                        <p className="mt-1 text-lg font-semibold text-white">
                          {stat.value}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mb-10 rounded-[2rem] border border-white/10 bg-white/95 p-4 shadow-2xl shadow-black/20 backdrop-blur-xl md:p-6 lg:p-8">
              <div className="rounded-[1.5rem] border border-slate-200 bg-white p-4 md:p-6">
                <div className="mt-2">
                  <Mission />
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};
